import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../common/components/Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects'
import { carbonWeightToNumberOfItems } from "../../common/util/converterUtils";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();
    
    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const numberOfWineBottlesImpact = fetchedImpact && !fetchedImpact.error && formatNumber(carbonWeightToNumberOfItems(fetchedImpact.carbonOffsetImpact?.value,fetchedImpact.carbonOffsetImpact?.unit,5));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    
    useEffect(() => {
        getProjects(null, merchantCode)
        .then(response => response.json())
        .then(data => setProjects(data))
        .catch(setProjects);

    }, []);


    return (
        <div>
            <div>
                <div className="center pt-3 pb-1">
                    <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1624863166/Enterprise/3sixty2/3sixty2_logo_ardjfd.png`} style={{height: '40px'}} />
                </div>
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent">
                <div className="container color-white text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="mw-600px">
                            <h1 className="mb-4 text-shadow mt-0">We’re going Climate Friendly for the planet</h1>
                        </div>
                        <div className="d-flex">
                            <p className="mr-2 mt-0">Powered By</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logo}/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container py-6">
                <div className="mw-800px our-story position-relative center py-6">
                    <div className="row">
                        <div className="col-6 d-grid mobile-hide">
                            <div className="img-cover img-bg position-relative vertical-align-parent">
                                <img style={{left: "-120px"}} className="h-240px position-absolute vertical-align shadow-lg" src={`https://res.cloudinary.com/carbonclick/image/upload/v1624876845/Enterprise/3sixty2/mug_rycbsr.png`} />
                            </div>
                        </div>
                        <div className="col-6 d-grid text-left color-primary">
                            <h2 className="font-medium">Our story starts with a number.</h2>
                            <p className="font-medium">3sixty2 marks the start of another story. A tale full of risks and vision and the spirit of adventure, set in Marlborough’s rocky soils. The journey of Alice Rule, young winemaker inspired by the past, who decided to go out on her own. A mover and a shaker who wanted to do things better, put things right, and honour the privilege of nature. With kaitiakitanga always in her mind Alice studied her craft, immersed herself in vines, and worked alongside New Zealand’s best – learning and growing and dreaming as she went. At 25, she realised she was ready. It was time to take ownership, to navigate her own path. Time to shake up the industry, one bottle at a time.</p>
                            <div className="mobile-show pt-3">
                                <img className="center mw-100" src={'https://res.cloudinary.com/carbonclick/image/upload/v1624861835/Enterprise/3sixty2/bottle_oeoneo.jpg'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <h5 className="mr-2 font-bold mt-0 mb-0">Powered By</h5>
                        <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                    </div>
                </div>
            </div>
            <div className="bg-tertiary color-primary py-6 img-contain">
                <div className="container-fluid">
                    <div className="row text-center align-items-center">
                        <div className="col-4 mb-3">
                            <h2 className="font-medium">{numberOfContributions}</h2>
                            <h5 className="font-medium">CLIMATE FRIENDLY PURCHASES</h5>
                        </div>
                        <div className="col-4 mb-3">
                            <h2 className="font-medium">{numberOfWineBottlesImpact} Bottles of Wine</h2>
                            <h5 className="font-medium">MADE CLIMATE FRIENDLY</h5>
                        </div>
                        <div className="col-4 mb-3">
                            <h2 className="font-medium">{carbonOffsetImpact} {carbonOffsetImpactUnit}</h2>
                            <h5 className="font-medium">CO2 OFFSET</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-primary color-secondary py-6 img-contain">
                <div className="container py-6">
                    <h2 className="font-medium center mw-600px">What are we doing to address climate change?</h2>
                    <div className="row pt-5">
                        <div className="col-4 text-center px-4 mb-5">
                            <div className="icon mb-5">
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861834/Enterprise/3sixty2/sustainability_matters_fdatmb.svg`}/>
                            </div>
                            <h5 className="font-medium">Sustainability Matters</h5>
                            <p className="">The capacity to endure. A sustainable business is one that generates profit while improving societal and environmental conditions.</p>
                        </div>
                        <div className="col-4 text-center px-4 mb-5">
                            <div className="icon mb-5">
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861834/Enterprise/3sixty2/sustainable_winegrowing_umoxi9.svg`}/>
                            </div>
                            <h5 className="font-medium">Sustainable Winegrowing NZ</h5>
                            <p className="">3Sixty2 are proud members of Sustainable Winegrowing NZ™ -widely recognised as a world-leading sustainability programme.</p>
                        </div>
                        <div className="col-4 text-center px-4">
                            <div className="icon mb-5">
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861836/Enterprise/3sixty2/kaitiakitanga_guardianship_jxezdc.svg`}/>
                            </div>
                            <h5 className="font-medium">Kaitiakitanga - Guardianship</h5>
                            <p className="">Kaitiakitanga is about conservation, of the land, sea and sky. It is the responsibility of all of us to respect and protect Mother Nature, and we consider it a privilege to be her guardians. </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-primary">
                <div className="container">
                    <div className="row">
                        <div className="col-6 mobile-show">
                            <img className="center mw-100" src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861835/Enterprise/3sixty2/alice_rule_girl_i6qvhi.jpg`} />
                        </div>
                        <div className="col-10 d-flex align-items-center gradient-1 px-5 color-secondary py-5">
                            <div className="col-7 text-right">
                                <h2 className="font-medium mb-4">Alice Rule</h2>
                                <h4 className="mb-4">When I was 25, I founded 3sixty2 with a dream to accelerate the circular economy in New Zealand wine.</h4>
                                <p>Alice founded 3Sixty2 on two guiding principles - sustainability and guardianship of the land - the principle of kaitiakitanga. As a start-up operation, Alice had to incorporate new technology into her business for better operating efficiency, making 3Sixity2 agile and not bound by legacy systems or ideologies.</p>
                            </div>
                        </div>
                        <div className="col-1 mb-5 pb-5 mobile-hide">
                            <img className="float-right mb-5 cus-shadow" src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861835/Enterprise/3sixty2/alice_rule_girl_i6qvhi.jpg`} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 img-bg-2 img-cover py-6">
                <div className="row justify-content-center py-6">
                    <div className="col-6 color-secondary">
                        <h2 className="font-medium my-0 text-right">Feeling Inspired?</h2>
                    </div>
                    <div className="col-6">
                        <a href="https://my.carbon.click" target="_blank" className="btn btn-secondary ml-0 ml-md-4">Start your climate action journey</a>
                    </div>
                </div>
            </div>
            <div className="py-6">
                <div className="container text-center">
                    <h2 className="font-bold mb-4">Climate Friendly FAQs</h2>
                    <div className="mb-3 bod-tb center text-left mw-800px">
                        <Accordian title={"What are carbon credits"} >A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.</Accordian>
                        <Accordian title={"How are carbon emissions calculated"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                    </div>
                </div>
            </div>
            <div className="bg-quaternary py-6">
                <div className="container text-center color-primary" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "right" }}>
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                        <div key="1" className="">
                            <div className="text-center center mw-720px">
                                <img className="testimonial-img" src={`https://res.cloudinary.com/carbonclick/image/upload/v1624861836/Enterprise/3sixty2/Ellipse_ego3hj.png`}/>
                                <h4 className="font-medium pb-5 mb-5">“ Our world needs protecting. And it’s on us – the young ones, the brave ones, the let’s try something new ones – to make sure that happens. ”</h4>
                                <h3 className="font-medium mt-5 mb-0">Alice Rule</h3>
                                <p className="font-medium mt-1 mb-0">Founder 3sixty2</p>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </div>
            {Array.isArray(projects) && <>
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Support Projects That Fight<br />Climate Change</h3>
                            <p>CarbonClick supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>}
            <div className="w-100 img-cover py-6 footer-bg" >
                <div className="container color-white">
                    <div className="d-flex justify-content-center mb-4 pb-2">
                        <p className="mr-2 mt-0">Powered By</p>
                        <a target="_blank" href={footerLinks?.carbonclick}><img style={{ height: 26 }} src={logo}/></a>
                    </div>
                    <hr className="mb-5" />
                    <div className="row color-white">
                        <div className="col-4 text-center mb-3">
                            <h5 className="mb-3 font-medium"><a className="color-white" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></h5>
                            <h5 className="mb-3 font-medium"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></h5>
                        </div>
                        <div className="col-4 text-center mb-3">
                            <h5 className="mb-3 font-medium"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></h5>
                            <h5 className="mb-3 font-medium"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></h5>
                        </div>
                        <div className="col-4 text-center">
                            <h5 className="mb-3 font-medium"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></h5>
                            <h5 className="mb-3 font-medium"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LandingPage;